

































import store from "@/store";
import { SelectionNotificationReceiver } from "@/service/SelectionNotificationReceiver";
import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import Navigation from "@/components/Navigation.vue";
import { NavigationItem } from "@/model/NavigationItem";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import { Getter, Action } from "vuex-class";
import requestService from "@/service/requestService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { NavigationItemParam } from "@/model/NavigationItemParam";
import { Utils } from "@/service/util";
import { SubHeaderData } from "@/model/SubHeaderData";
import { InspectTime } from "@/model/InspectTime";
import { SpentTime } from "@/model/SpentTime";
import { SeibiItem } from "@/model/InspectionSeibi";
import { INSPECT_TYPE } from "@/model/InspectType";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import SideTabRight from "@/components/SideTabRight.vue";
import { InspectionShakenShuruiDetailStoreService } from "@/service/InspectionShakenShuruiDetailStoreService";
import { InspectionInspectLineDetailStoreService } from "@/service/InspectionInspectLineDetailStoreService";
/** 2021-07-14 sh #7289 if change shaken menu, it show notification. [START] */
import { MESSAGE } from "@/model/Message";
/** 2021-07-14 sh #7289 if change shaken menu, it show notification. [END] */

@Component({
  components: {
    Header,
    SubHeader,
    Navigation,
    appSideTabRight: SideTabRight
  }
})
export default class MainInspection extends Vue {
  activePage: number = 0;
  navItems: NavigationItem[] = [];
  navigationVersion = 0;
  navigationVerifiedPath = "";
  isUserMode: boolean = true;
  line: string = "3";
  title: string = "";
  textTopTitle: string = "";
  hasBtn: boolean = false;
  reqService: requestService;
  ippanSeibiService: IppanSeibiService;
  sktControll: SocketControllers;
  startTime: number = 0;
  clientStartTime: number = 0;
  timerSpentTime: any = null;
  expectedTimer: number = 0;
  isEditPrice: boolean = false;
  isUserConfirmPayment: boolean = false;
  userService: UserService;
  canEditSoukou: boolean = false;
  isReady: boolean = false;

  onUserConfirmUpdating: boolean = false;
  optionCouponUpdating: boolean = false; // 更新処理中フラグ（手数料/オプション（通常版）、保証（NEX版）、クーポン（両方））

  isExitConnectSocket: boolean = false;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Action("setMaintenanceExpectTime", { namespace: "SubHeader" })
  setMaintenanceExpectTime: any;

  @Action("setIsSavePaymente", { namespace: "SubHeader" })
  setIsSavePaymente: any;

  @Getter("isSavePayment", { namespace: "SubHeader" })
  isSavePayment: boolean;

  // for user
  @Getter("isConfirmLegal56", { namespace: "InspectSeibi" })
  isConfirmLegal56: any;
  @Getter("isConfirmRecommend", { namespace: "InspectSeibi" })
  isConfirmRecommend: any;
  @Getter("isConfirm", { namespace: "Shohiyou" })
  isConfirmShohiyou: any;
  @Getter("isConfirm", { namespace: "Coupon" })
  isConfirmCoupon: any;
  @Getter("waitingAutoSave", { namespace: "Coupon" })
  waitingAutoSaveCoupon: any;
  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];
  @Getter("isConfirm", { namespace: "Option" })
  isConfirmOption: any;
  @Getter("waitingAutoSave", { namespace: "Option" })
  waitingAutoSaveOption: any;

  @Getter("getSeibiData", { namespace: "InspectSeibi" })
  seibi: any;
  @Getter("getManualSeibiData", { namespace: "InspectSeibi" })
  seibiManual: any;
  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;

  @Getter("isConfirmNex", { namespace: "Payment" })
  isConfirmPaymentNex: number;
  @Action("confirm", { namespace: "Payment" })
  confirmPayment: any;
  @Action("confirm", { namespace: "InspectSeibi" })
  confirmRecommend: any;
  @Action("setSeibiData", { namespace: "InspectSeibi" })
  setSeibiData: any;

  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;

  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */

  /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
  @Action("setState", { namespace: "RouteState" })
  setRouteState: any;
  /** 2021-11-22 sh #7530 improve speed.(for back) [END] */

  @Action("setSeibiData", { namespace: "InspectSeibiAK3" })
  setSeibiAK3Data: any;

  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  inspectionDetailStoreService1: InspectionShakenShuruiDetailStoreService =
    new InspectionShakenShuruiDetailStoreService();
  inspectionDetailStoreService3: InspectionInspectLineDetailStoreService =
    new InspectionInspectLineDetailStoreService();

  public utils: Utils = new Utils();

  $refs!: {
    subHeader: SubHeader;
    nav: Navigation;
    subPage: any;
    sideTab: SideTabRight;
  };

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.onReconnect(() => this.selectionReceiver.receive());
    ["updateCourseSubscription", "inspectSubscriptionDetail", "couponSubscription", "optionSubscription"]
      .forEach(key => this.sktControll.socketEntry(key, this.onSelectionChanged));
    if (this.isUserMode) {
      this.sktControll.socketEntry("navSubscription",this.onUpdateNavigation); // catchSocket:ソケット仮14
      this.sktControll.socketEntry("buhinSubscription",this.onBuhinNotify); // catchSocket:ソケット仮22

      // catchSocket:17車検検査費用と車検基本費用の編集
      this.sktControll.socketEntry("kensaHiyouSubscription",this.onReloadKensaHiyou);
      this.sktControll.socketEntry("shohiyouSubscriptionComp",this.onUpdateShouhiyou, true); // catchSocket:15車検諸費用の編集
      // catchSocket:13するしない後日編集
      this.sktControll.socketEntry("doTenkenSubscribe",this.onInspectionDotenken);

      // catchSocket:ソケット仮27// catchSocket:ソケット仮28
      this.sktControll.socketEntry("jizenRecommendSubscribe",this.onInspectionDotenken);
      this.sktControll.socketEntry("inspectSubscription",this.onInspectItemcompleted); // catchSocket:ソケット仮04
      this.sktControll.socketEntry("inspectSeibiSubscribe",this.onSeibiItemcompleted); // catchSocket:ソケット仮06
    }
    this.sktControll.socketEntry("ak7Subscribe",this.onPayments); // catchSocket:ソケット仮34
    this.sktControll.connectSocket();
  }

  async created() {
    this.reqService = new requestService();
    this.ippanSeibiService = new IppanSeibiService();
    this.userService = new UserService();
    this.isUserMode = this.$route.meta == "user";
    try {
      this.connectSocket();

      if (this.inspectLine && this.inspectLine.length > 0) {
        this.line = this.inspectLine[0].kbnKey;
      }
      await this.getNavigation();
      if (this.isUserMode) {
        this.title = this.ippanSeibiService.getIppanSeibiLabel('車検の進行状況');
      }
    } finally {
      this.isReady = true;
    }
  }

  get inspectLine(): any {
    return this.inspectionDetailStoreService3.selectedInspectLine;
  }

  get canDisplayCurrentPage() {
    // 中間待機画面はナビゲーションに載らない補助画面。
    if (this.isUserMode || ["standby", "standby1"].indexOf(this.$route.name || "") >= 0) { return true; }
    return this.navigationVerifiedPath === this.$route.fullPath && this.navItems.some(item =>
      item.page === this.$route.name && item.isNavigation != 0);
  }

  @Watch("$route")
  onNavigationRouteChanged() {
    if (!this.isUserMode) {
      this.getNavigation();
    }
  }

  async getNavigation() {
    const version = ++this.navigationVersion;
    const path = this.$route.fullPath;
    try {
      const res = await this.reqService.getNavigation(this.uketsukeExtendsId, this.isUserMode);
      if (version !== this.navigationVersion || this.selectionReceiver.disposed) { return; }
      this.$set(this, "navItems", res || []);
      this.navigationVerifiedPath = path;
      if (!this.isUserMode) { this.activePage = Math.max(0, this.findPageNumber(this.$route.name || "")); }
      if (!this.canDisplayCurrentPage && path === this.$route.fullPath) {
        const next = this.navItems.find(item => !!item.page && item.isNavigation != 0);
        if (next) {
          // 自動保存を通さず、ナビゲーションで利用可能な画面へ移動する。
          this.$router.replace({ name: next.page });
        }
      }
    } catch (error) {
      if (version === this.navigationVersion && !this.selectionReceiver.disposed) {
        this.$notify.error({ title: "更新エラー", message: "ナビゲーションを取得できませんでした。画面を開き直してください。" });
      }
    }
  }

  setStartTime() {
    this.clientStartTime = new Date().getTime();
    this.reqService.asyncGetServerTime().then(time => {
      this.startTime = time;
    });
  }

  setTimerSpentTime() {
    this.clearTimerSpentTime();
    let interval = 60000;
    let dt = new Date().getTime() - this.clientStartTime;
    if (dt <= interval) {
      this.timerSpentTime = setTimeout(
        this.saveSpentTime,
        Math.max(0, interval - dt)
      );
    }
  }

  clearTimerSpentTime() {
    if (this.timerSpentTime) {
      clearTimeout(this.timerSpentTime);
      this.timerSpentTime = null;
    }
  }

  onActive(pageName: string) {
    if (this.$route.name === "carselection") {
      this.canEditSoukou = true;
    } else {
      this.canEditSoukou = false;
    }
    if (pageName === "estimate") {
      this.updateTSknUketsukeExtends();
    }
    this.$forceUpdate();
    if (this.navItems.length == 0) {
      setTimeout(() => {
        this.onActive(pageName);
      }, 500);
      return;
    }
    this.$refs.nav.checkLockNavigation();
    const page = this.findPageNumber(pageName);
    if (page > -1) {
      this.setStartTime();
      this.setTimerSpentTime();
      this.activePage = page;
      const item = this.navItems[this.activePage];
      if (item.status == NAVIGATION_STATUS.INACTIVE) {
        item.status = NAVIGATION_STATUS.ACTIVE;
        /** 2022-02-04 sh #7710 duplicate send. [START] */
        // this.sendPutNavigation(item);
        /** 2つのリクエストが送信されるので、タイミングをずらすようにする */
        setTimeout(() => {
          this.sendPutNavigation(item);
        }, 1000);
        /** 2022-02-04 sh #7710 duplicate send. [END] */
      }
      if (this.$route.name != item.page) {
        // this.$refs.subHeader.getSubHeaderData();
        this.goToPage(item.page);
      }
    }
  }

  onRegister(data: {
    pageName: string;
    status: string;
    notCurrentActive: boolean;
  }) {
    // console.log("MainInspection.onRegister data => ", data, this.activePage, this.navItems);
    this.clearTimerSpentTime();
    const page = this.findPageNumber(data.pageName);
    if (page == this.activePage) {
      if (this.activePage < this.navItems.length - 1) {
        let status = data.status;
        if (!data.status) {
          status = NAVIGATION_STATUS.REGISTER;
        }
        this.navItems[this.activePage].status = status;
        this.updateWorkProgressState();
        this.sendPutNavigation(this.navItems[this.activePage]);
        if (this.navItems[this.activePage].page == "legal56") {
          this.goToStandbyPage();
        } else if (this.ippanSeibiService.isIppanSeibi && this.navItems[this.activePage].page == "estimate") {
          // 一般整備の場合は「現車確認」と「57項目点検」が非活性なので、事前見積画面の次は「検査が全て終了しました」へ遷移する。
          this.goToStandbyPage();
        } else if (this.navItems[this.activePage].page == "recmaintenance") {
          this.$router.push({ name: "partsselect" });
        } else if (this.navItems[this.activePage].page == "partsselect") {
          // let page = this.isSavePayment ? "3" : "2";
          this.$router.push({ name: "standby", params: { page: this.isSavePayment ? "3" : "2" }});
        } else {
          this.activePage++;
          const item = this.navItems[this.activePage];
          this.onActive(item.page);
        }
      } else {
        this.navItems[this.activePage].status = NAVIGATION_STATUS.REGISTER;
        this.sendPutNavigation(this.navItems[this.activePage]);
        this.$router.push({ name: "additional-maintenance" });
      }
    } else if (data.notCurrentActive) {
      /** 2021-08-17 sh #7342 fix script error for implements jizen mitsumori. [START] */
      if (page > -1) {
        this.navItems[page].status = NAVIGATION_STATUS.REGISTER;
        this.sendPutNavigation(this.navItems[page]);
      }
      /** 2021-08-17 sh #7342 fix script error for implements jizen mitsumori. [END] */
    /** 2021-11-25 sh #7570 Pressing a button, it does not work. [START] */
    } else if (data.pageName == "estimate" && this.activePage == 3) {
      /** 現車確認から事前見積もりの見積結果画面へ戻った場合、activePageを減らす */
      this.activePage--;
      this.onRegister(data);
    /** 2021-11-25 sh #7570 Pressing a button, it does not work. [END] */
    }
  }

  findPageNumber(pageName: string) {
    return this.navItems.findIndex(
      (nav: NavigationItem) => nav.page == pageName
    );
  }

  onChangePage(page: number) {
    this.activePage = page;
    const navItem = this.navItems[page];
    if (navItem && navItem.page) {
      this.onActive(navItem.page);
    }
  }

  goToPage(page: string | undefined) {
    /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
    if (page == "currentcarcheck") {
      this.setRouteState( {date: {}, index: INSPECT_TYPE.GENSHA} );
    } else if (page == "legal56") {
      this.setRouteState( {date: {}, index: INSPECT_TYPE.LEGAL56} );
    } else if (page == "jizen") {
      this.setRouteState( {date: {}, index: INSPECT_TYPE.JIZEN} );
    } else if (page == "recmaintenance") {
      this.setRouteState( {date: {}, index: INSPECT_TYPE.RECOMMEND} );
    }
    /** 2021-11-22 sh #7530 improve speed.(for back) [END] */
    this.$nextTick(() => {
      this.$router.push({ name: page });
    });
  }

  goToStandbyPage() {
    this.clearTimerSpentTime();
    this.$router.push({ name: "standby", params: { page: "1" } });
  }

  startMaintenance() {
    this.$refs.subHeader.setMaintenanceMinute();
  }

  sendPutNavigation(item: NavigationItem, retCnt: any = 0) {
    const param: NavigationItemParam = {
      uketsukeExtendId: this.uketsukeExtendsId,
      screenId: item.screenId,
      status: item.status
    };
    // sendSocket:ソケット仮14
    this.reqService.putNavigation(param).then(
      (res: any) => {},
      (error: any) => {
        /** 2021-12-13 sh #7557 fix dead lock. [START] */
        // console.log("save navigation error wait 1s to auto retry");
        // setTimeout(() => {
        //  this.sendPutNavigation(item);
        // }, 1000);
        if (error && error.status && error.status == 409 && retCnt < 10) {
          /** 409のステータスが発生した時だけ、リトライする。最大：10回まで(dead lock.) */
          setTimeout(() => {
            retCnt++;
            // console.log("save navigation error wait 1s to auto retry", retCnt);
            this.sendPutNavigation(item, retCnt);
          }, 1000);
        }
        /** 2021-12-13 sh #7557 fix dead lock. [END] */
      }
    );
  }

  socketShohiyouRollback(frame: any) {
    // 複数のソケット通信をしているので処理をまとめる
    if (this.isUserMode) {
      this.onReloadShouhiyou(frame);
    } else {
      /** ユーザ画面で車検の種類が変更された場合の処理を行う. */
      this.onReloadAfterShakenShurui(frame);
    }

  }

  onInspectItemcompleted(frame: any) {
    const body = this.utils.getWSData(frame);
    const seibi = { ...body };
    delete seibi.sknWorkProgressState;
    delete seibi.sknWorkProgressStateNm;
    this.setSeibiAK3Data(seibi);
    // this.notify();
    // this.loopFirstDoTenken(this.listInspect[1]);
  }

  onSeibiItemcompleted(frame: any) {
    const body = this.utils.getWSData(frame);
    const seibi = { ...body };
    delete seibi.items.sknWorkProgressState;
    delete seibi.items.sknWorkProgressStateNm;
    this.setSeibiData(seibi); // inspectSeibiStoreデータセット
  }

  onUpdateShouhiyou(frame: any) {
    this.userService.getShohiyou();
    const body = this.utils.getWSData(frame);
    this.userService.updateConfirm(body.sknUketsukeUserJouhou);
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  onReloadAfterShakenShurui(frame: any) {
    const body = this.utils.getWSData(frame);
    if (body && body.shakenShuruiSeibiMenuCd) {
      if (body.screen && body.screen != this.$route.meta) {
        this.inspectionDetailStoreService1.setSeibiMenuCd(body.shakenShuruiSeibiMenuCd);
      }
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  onUpdateCoupon(frame: any) {
    this.userService.getCoupon();
    const body = this.utils.getWSData(frame);
    this.userService.updateConfirm(body.sknUketsukeUserJouhou);
  }

  onPayments(frame: any) {
    const body = this.utils.getWSData(frame);
    const maintenaceMinute = body.sknMaintenanceExpectTime.toFixed(0);
    this.setMaintenanceExpectTime(body.sknMaintenanceExpectTime);
    this.$refs.subHeader.setMaintenanceMinute();
    this.$refs.subHeader.setMaintenanceZero();
    this.setIsSavePaymente();
    if (this.$route.name == "standby") {
      this.$router.push({ name: "standby", params: { page: "3" } });
    }
    if (this.isUserMode) {
      if (this.isUserConfirmPayment) {
        this.$router.push({ name: "usercomplete" });
      } else {
        this.isUserConfirmPayment = false;
      }
    }
  }

  onUpdateNavigation(frame: any) {
    const body = this.utils.getWSData(frame);
    this.navItems = body;
    if (this.navItems && this.navItems.length !== 0) {
      if (this.navItems[3].status == "2" && this.isUserMode) {
        const listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);
        if (listRecommend.length === 0) {
          this.confirmRecommend({ type: INSPECT_TYPE.RECOMMEND, value: 1 });
        }
      }
    }
  }

  saveSpentTime(doClearTimer?: boolean) {
    let now = new Date().getTime();
    let stopTime = this.startTime + (now - this.clientStartTime);
    this.clientStartTime = now;
    if (doClearTimer) {
      this.clearTimerSpentTime();
    } else {
      this.setTimerSpentTime();
    }
    let navFiltered = this.navItems.filter(nav => nav.page == this.$route.name);
    let screenId = "";
    if (navFiltered.length > 0) {
      screenId = navFiltered[0].screenId;
    }

    // console.log( "saveSpentTime screenId " + screenId, stopTime - this.startTime);
    if (screenId == "") {
      this.clearTimerSpentTime();
    } else {
      const spent: SpentTime = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        startTime: this.startTime,
        stopTime,
        screenId,
        uketsukeCd: this.uketsukeCd,
        yoyakuNo: this.yoyakuNo
      };
      // sendSocket:ソケット仮10
      this.reqService.saveSpentTime(spent).then(
        res => {
          this.startTime = stopTime;
          if (!this.sktControll.checkSocket()) {
            this.$refs.subHeader.getSubHeaderData();
          }
        },
        error => {
          if (stopTime - this.startTime >= 60000) {
            if (screenId == "6") {
              // maintenance
              this.$refs.subHeader.setTempMaitenaceMinute();
            } else {
              // inspect
              this.$refs.subHeader.setTempInspectMinute();
            }
          }
        }
      );
    }
  }

  /** 2021-06-02 sh #7123 if change price, get the flag form server. [START] */
  onUserConfirmSync() {
    /** サーバ側と同期をするためここで再読み込みをする */
    let promise = this.userService.getConfirmPM();
    Promise.all([promise]).then((val: any) => {
      this.onUserConfirm();
    });
  }
  /** 2021-06-02 sh #7123 if change price, get the flag form server. [END] */

  onUserConfirm() {

    let listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);
    if (
      (this.isConfirmShohiyou || this.ippanSeibiService.isIppanSeibi) &&
      this.isConfirmOption &&
      this.isConfirmCoupon &&
      this.isConfirmLegal56 &&
      (listRecommend.length == 0 || this.isConfirmRecommend) &&
      // ネクステージの場合最低料金確定を条件追加する
      ( this.isNextageCustom && this.isConfirmPaymentNex == 2 )
    ) {
      this.$set(this, "onUserConfirmUpdating", true);
      const dataForSave = this.userService.getDataForSaveAk7(
        this.seibi,
        this.seibiManual,
        this.sumPrice(INSPECT_TYPE.LEGAL56),
        this.sumPrice(INSPECT_TYPE.RECOMMEND)
      );
      this.isUserConfirmPayment = false;
      this.reqService.savePayment(dataForSave).then(res => { // sendSocket:ソケット仮34
        this.$set(this, "onUserConfirmUpdating", false);
        this.confirmPayment(1);// ここで更新
      }, () => {
        this.$set(this, "onUserConfirmUpdating", false);
      });
    }
  }

  onConfirmPayment() {
    this.isUserConfirmPayment = true;
  }

  updateWorkProgressState() {
    // sendSocket:ソケット仮33
    if (["MD0004", "MD0006", "MD0008"].indexOf(this.navItems[this.activePage].screenCd) > -1) {
      const data = {
        screenCd: this.navItems[this.activePage].screenCd,
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        currentWorkProgressState: this.stateId,
        uketsukeCd: this.uketsukeCd,
        yoyakuNo: this.yoyakuNo
      };
      this.reqService.updateWorkProgressState(data);
    }
  }

  onBuhinNotify(frame: any) {
    const list = this.utils.getWSData(frame);
    list.forEach((buhin: any) => {
      setTimeout(() => {
        this.$notify({
          title: buhin.buhinNm,
          dangerouslyUseHTMLString: true,
          message: buhin.oldBuhinPrice + "<br/>" + buhin.newBuhinPrice
        });
      }, 300);
    });
  }

  destroyed() {
    this.selectionReceiver.dispose();
    /** 2021-07-16 sh #7190 clear timer [START] */
    this.clearTimerSpentTime();
    /** 2021-07-16 sh #7190 clear timer [END] */
  }

  onActiveSideTab(key: string) {
    if (this.$refs.sideTab) {
      this.$refs.sideTab.onActive(key);
    }
  }

  onConfirmSideTab(key: string) {
    if (this.$refs.sideTab) {
      this.$refs.sideTab.onConfirm(key);
    }
  }

  onUpdateSideTab(key: string) {
    if (this.$refs.sideTab) {
      this.$refs.sideTab.onUpdate(key);// 
      // onConfirm(index: number) {
    }
  }

  /** 2021-07-14 sh #7289 if change shaken menu, it show notification. [START] */
  onReloadShouhiyou(frame: any) {
    this.userService.getShohiyou();
    const body = this.utils.getWSData(frame);
    this.userService.updateConfirm(body.sknUketsukeUserJouhou);
    this.$notify.info({
      title: "Info",
      message: this.isNextageCustom ? MESSAGE.UpdatedShakenCouseNex :
        (this.ippanSeibiService.isIppanSeibi ? MESSAGE.UpdatedShakenCouseIppanSeibi : MESSAGE.UpdatedShakenCouse)
    });
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.userService.getSeibi();
    if (this.isUserMode && body.shakenShuruiSeibiMenuCd) {
      this.inspectionDetailStoreService1.setSeibiMenuCd(body.shakenShuruiSeibiMenuCd);
    }
    if (this.$route.name == "statusresult") {
      this.onReloaseShohiyouWithSettimeiout();
    } else if (this.$route.name == "workdetail") {
      this.onReloaseShohiyouWithSettimeiout();
    }
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  }
  /** 2021-07-14 sh #7289 if change shaken menu, it show notification. [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  onReloaseShohiyouWithSettimeiout(msec: number = 1000) {
    setTimeout(() => {
      // 整備対象リスト用意(ユーザー側)
      this.userService.getSeibiAK3();
    }, msec);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  /** 2021-08-17 sh #7343 get seibi after recieved socket. [START] */
  onInspectionDotenken() {
    this.userService.getSeibi();
  }
  /** 2021-08-17 sh #7343 get seibi after recieved socket. [END] */

  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
  onReloadKensaHiyou() {
    if (this.isUserMode) {
      const promise = this.userService.getKensaHiyouPM();
      Promise.all([promise]).then(() => {});
    }
  }
  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */
  updateTSknUketsukeExtends() {
  this.reqService.updateTSknUketsukeExtends(this.uketsukeExtendsId).then(
    (res: any) => {
    },
    (err: any) => {
    }
  );
  }

  /** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
  onUpdateOption() {
    this.userService.getOption();
  }
  /** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  selectionReceiver = this.createSelectionReceiver();

  // Vueに束縛されたメソッド内で生成し、コールバックが実インスタンスを参照するようにする。
  createSelectionReceiver() {
    return new SelectionNotificationReceiver({
      context: () => ({
        request: this.reqService, id: this.uketsukeExtendsId,
        kbn: store.getters["ReservationDetail/sknSeibiShubetsuKbn"] || 0
      }),
      apply: snapshot => this.applySelectionSnapshot(snapshot),
      onError: () => this.$notify.error({ title: "更新エラー", message: "他画面の変更を取得できませんでした。画面を開き直してください。" }),
    });
  }


  onSelectionChanged(frame?: any) {
    return this.selectionReceiver.receive(frame && this.utils.getWSData(frame));
  }

  applySelectionSnapshot(snapshot: any) {
    const { detail, option, coupon } = snapshot;
    this.getNavigation();
    if (Object.prototype.hasOwnProperty.call(detail, "jizenCd")) {
      store.dispatch("InspectionDetail/setJizenCd", detail.jizenCd);
      store.dispatch("InspectionDetail/setInspectLineCd", detail.inspectLineCd);
    }
    const changedCourse = String(this.inspectionDetailStoreService1.seibiMenuCd)
      !== String(detail.shakenShuruiSeibiMenuCd);
    this.inspectionDetailStoreService1.setSeibiMenuCd(detail.shakenShuruiSeibiMenuCd);
    store.dispatch("Option/setOptionFromSocket", option);
    store.dispatch("Coupon/setCouponFromSocket", coupon);
    if (changedCourse) {
      this.userService.getShohiyou();
      this.userService.getSeibi();
      if (this.$route.name === "statusresult" || this.$route.name === "workdetail") {
        this.onReloaseShohiyouWithSettimeiout();
      }
    }
  }

  onStartInspect(frame: any) {
    const body = this.utils.getWSData(frame);
    if (body && body.seibiMenuCd) {
      this.inspectionDetailStoreService1.setSeibiMenuCd(body.seibiMenuCd);
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  onSelect() {
    // 右サイドバークリック時に、遷移前のページがクーポン（両方）、手数料/オプション（通常版）、または保証（NEX版）の場合は一時保存する
    if (((this.$route.name === 'option' && !this.isNextageCustom) ||
        (this.$route.name === 'soukouhosho' && this.isNextageCustom)) &&
        typeof this.$refs.subPage.onSave === 'function') {
      if ( this.isConfirmOption == 0 || this.waitingAutoSaveOption == 1 ) {
        this.$refs.subPage.onSave();
      }
    } else if (this.$route.name === 'discountcoupon' && typeof this.$refs.subPage.onSave === 'function') {
      if ( this.isConfirmCoupon == 0 || this.waitingAutoSaveCoupon == 1 ) {
        this.$refs.subPage.onSave();
      }
    }
  }
  async onOptionCouponUpdating(promise: Promise<any>) {
    // クーポン、手数料/オプション、または保証保存時に右サイドバーを無効化する
    this.optionCouponUpdating = true;
    await promise;
    this.optionCouponUpdating = false;
  }
}
